import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Row, Button } from '_zari/core'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

import * as FormGroups from './formGroups'

const FiltrosSection = ({ innerRef, actualizarListaDocumentos }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      fecha: ''
    }),
    []
  )

  const clickBuscarFechaPendiente = React.useCallback(
    ({ setFieldValue, setSubmitting }) => {
      setSubmitting(true)
      __zariContext.loader.open('Buscando fecha pendiente')

      FacturacionHistorialService.obtenerPrimerPendienteResumen()
        .then(({ data }) => {
          setFieldValue('fecha', data.fecha)
        })
        .catch(() => {
          __zariContext.snack('error', 'No se pudo obtener la fecha.')
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  const onSubmit = React.useCallback(
    ({ fecha }, { setSubmitting }) => {
      __zariContext.loader.open('Buscando documentos pendientes.')

      FacturacionHistorialService.obtenerAsEmisorResumen({ fecha })
        .then(({ data }) => {
          actualizarListaDocumentos(data)
          __zariContext.toast('success', 'Lista de documentos actualizados.')
        })
        .catch(() => {
          __zariContext.snack('error', 'No se pudo obtener los documentos pendientes.')
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext, actualizarListaDocumentos]
  )

  return (
    <Formik innerRef={innerRef} initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting, handleSubmit, setFieldValue, setSubmitting }) => (
        <Form>
          <Row className='px-4'>
            <Col md={2}>
              <Button
                onClick={() => clickBuscarFechaPendiente({ setFieldValue, setSubmitting })}
                disabled={isSubmitting}
                color='warning'
                outline
                tiny
                block
              >
                Buscar fecha pendiente
              </Button>
            </Col>
            <Col md={3}>
              <FormGroups.FechaFormGroup iTouched={touched.fecha} iError={errors.fecha} fIsSubmitting={isSubmitting} />
            </Col>
            <Col md={1}>
              <Button onClick={handleSubmit} disabled={isSubmitting} tiny block>
                Consultar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(FiltrosSection)
